export const YARA_CODE_EDITOR_OPTIONS = {
  editorOptions: {
    fontFamily: 'IBMPlex, sans-serif',
    fontWeight: '400',
    fontSize: 12,
    fontLigatures: '',
    lineNumbers: 'on',
    wordWrap: 'on',
    lineNumbersMinChars: 3,
    overviewRulerBorder: true,
    value: ``,
    quickSuggestions: {
      strings: false,
      other: false,
      comments: false,
    },
    fixedOverflowWidgets: true,
    lineDecorationsWidth: 10,
    bracketPairColorization: {
      enabled: true,
    },
    scrollbar: {
      vertical: 'visible',
    },
    glyphMargin: true,
  },
  languageOptions: {
    validate: false,
    autoComplete: false,
    hover: false,
  },
};
